<template>
    <b-row>
        <div class="col-sm-12 mt-3">
            <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                <thead>
                    <tr>
                        <th style="width: 20%;text-align: center;">
                            Suscursal
                        </th>
                        <th style="width: 10%;text-align: center;">
                            Fecha
                        </th>
                        <th style="width: 60%;">
                            Comentario
                        </th>
                        <th style="width: 10%;text-align: center;">
                            ...
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in registros" :key="index">
                        <td style="text-align: center;">
                            {{ convertir_codigo_a_sucursal(item.sucursal) }}
                        </td>
                        <td style="text-align: center;">
                            {{ item.fecha }}
                        </td>
                        <td>
                            {{ item.comentarios }}
                        </td>
                        <td style="text-align: center;">
                            <button type="button" style="font-size: 9px;" class="btn btn-sm btn-outline-dark"
                                @click="abrir_modal_detalle(item)"><i class="fas fa-eye"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <DetalleSolicitud v-if="modal_detalle" v-on:salir="cerrar_modal_detalle"
            v-on:actualizar_pendientes="obtener_solicitudes" />
    </b-row>

</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import DetalleSolicitud from './DetalleSolicitud.vue';

    export default {
        name: 'Pendientes',
        computed: {
            ...mapState(['id_empresa_seleccionada', 'datos_usuario', 'sucursales'])
        },
        components: {
            DetalleSolicitud
        },
        data() {
            return {
                registros: [],
                modal_detalle: false
            }
        },
        methods: {
            async obtener_solicitudes() {
                let f = {
                    api: `solicitud-descuentos?filters[empresa][$eq][0]=${this.id_empresa_seleccionada}&filters[estado][$eq][1]=PENDIENTE`
                }

                let r = await this.obtener_data(f)
                this.registros = r
            },
            convertir_codigo_a_sucursal(codigo) {
                if (codigo == null || codigo == '' || codigo == undefined) {
                    return 'N/A'
                } else {

                    let i = this.sucursales.findIndex(item => item.codigo == codigo)
                    return this.sucursales[i].nombre
                }
            },
            abrir_modal_detalle(item) {
                this.set_obj_solicitudes_descuento_admon(item)
                this.modal_detalle = true
            },
            cerrar_modal_detalle() {
                this.modal_detalle = false
            },
            ...mapActions(['obtener_data']),
            ...mapMutations(['set_obj_solicitudes_descuento_admon'])
        },
        mounted() {
            this.obtener_solicitudes()
        },
    }
</script>

<style></style>